/**
 * Capitalize a string
 *
 * @return {string}       Capitalized string
 */
String.prototype.capitalize = function () {
    return this.charAt(0).toUpperCase() + this.slice(1);
}



// WEBPACK FOOTER //
// ./src/js/lib/string/capitalize.js